import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { injectConfigProperty } from '@cosmos/config';
import { EspRestClient } from '@esp/common/data-access-rest-client';
import type { LookupApiModel } from '@esp/lookup/types-lookup';

@Injectable({
  providedIn: 'root',
})
export class LookupsApiService extends EspRestClient {
  override url = 'types';

  constructor() {
    super(injectConfigProperty('espServiceApiUrl'));
  }

  getLookups(): Observable<LookupApiModel> {
    const uri = `${this.uri}/lookups`;

    return this.http.get<LookupApiModel>(uri);
  }

  getType<
    TKey extends keyof LookupApiModel,
    TValue extends LookupApiModel[TKey],
  >(type: TKey): Observable<TValue> {
    const uri = `${this.uri}/${type.toLowerCase()}`;

    return this.http.get<TValue>(uri);
  }
}
